import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, tap } from 'rxjs';
import { ConfigService } from '../config.service';
import { McDataMapService } from './mc-data-map.service';
import { Contact, ContactRoles } from './types/contacts';
import { FundraisingStatus } from './commonInterfaces';

export interface ContactUpdatedArgs {
  contactId: number,
  contact: Contact | null,
  operation: "added" | "updated" | "deleted"
}

export interface CreateContactParams extends Required<Pick<Contact, "custId" | "prefix" | "firstName" | "middleName" | "lastName" | "jobTitle" | "role" | "email" | "address1" | "address2" | "city" | "stateprov" | "zipcode" | "country" | "phone1" | "phone1Type" | "phone2" | "phone2Type" | "phone3" | "phone3Type" | "subscription">> {

}

export interface UpdateContactParams extends Omit<CreateContactParams, "custId"> {
  id: number
}

export interface DeleteContactParams {
  id: number
}

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  private contactUpdatedSubject = new Subject<ContactUpdatedArgs>()
  contactUpdated = this.contactUpdatedSubject.asObservable()

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private mcDataMapService: McDataMapService
  ) { }

  get unassignedContact(): Contact {
    return {
      id: 0,
      firstName: "Unassigned",
      inactive: 0,
      timestamp: new Date()
    }
  }

  getContactsForCustomer(custId: number) {
    return this.http.get<Contact[]>(`${this.config.dataApiUrl}/customers/${custId.toString()}/contacts`)
  }

  getContactsFromIds(ids: number[]) {
    return this.http.get<Contact[]>(`${this.config.dataApiUrl}/contacts/from-list`, { params: { ids } })
  }

  createContact(contact: CreateContactParams) {
    return this.http.post<Contact>(`${this.config.dataApiUrl}/contacts`, { ...contact, inactive: 0 }).pipe(
      tap(newContact => this.contactUpdatedSubject.next({ contact: newContact, contactId: newContact.id, operation: "added" }))
    )
  }

  updateContact(contact: UpdateContactParams) {
    return this.http.put<Contact>(`${this.config.dataApiUrl}/contacts`, { ...contact, inactive: 0 }).pipe(
      tap(contact => this.contactUpdatedSubject.next({ contact: contact, contactId: contact.id, operation: "updated" }))
    )
  }

  deleteContact(contact: DeleteContactParams) {
    return this.http.delete(`${this.config.dataApiUrl}/contacts/${contact.id.toString()}`).pipe(
      tap(result => this.contactUpdatedSubject.next({ contact: null, contactId: contact.id, operation: "deleted" }))
    )
  }


}
